import React from 'react';
import cx from 'classnames';
import { SERVICES_NUMBER } from '../../../../utils/productType';
import styles from '../DataAdvertisement.module.css';
import { getInfo } from '../utils/getInfo';

interface Props {
  data: any;
}

export const Datasheet = ({ data }: Props) => {
  const { type } = data;
  const containerAd = cx('pt24 pb24 relative', styles.boxAd);

  const newType = parseFloat(type) === SERVICES_NUMBER ? parseFloat(type) + 1 : type;

  return (
    <section className={containerAd}>
      <h2 className="f16 fw6 abbey ma0 mb8 mb16">Ficha técnica</h2>
      {getInfo(newType, data)}
    </section>
  );
};
